module.exports = __webpack_public_path__ + "img/sa.96aac078.svg";